// src/components/link-icon-list/link-icon-list.tsx
import { tv } from "tailwind-variants";
import { Link } from "../link/link.mjs";
import { jsx } from "react/jsx-runtime";
var linkIconList = tv({
  slots: {
    container: "flex justify-center gap-4",
    item: "w-8 h-8 bg-secondary hover:bg-main rounded-full group p-2 transition duration-300",
    icon: "fill-main bg-secondary group-hover:fill-secondary group-hover:bg-main transition duration-300"
  }
});
var style = linkIconList();
var LinkIconListItem = ({
  item: { label, link, icon: Icon },
  track
}) => /* @__PURE__ */ jsx(Link, { href: link, className: style.item(), "aria-label": label, track, children: /* @__PURE__ */ jsx(Icon, { className: style.icon() }) });
var LinkIconList = ({
  items,
  className,
  track
}) => /* @__PURE__ */ jsx("div", { className: style.container({ className }), children: items.map((item) => /* @__PURE__ */ jsx(LinkIconListItem, { item, track }, item.label)) });
export {
  LinkIconList
};
